import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import AddPackageDetails from 'components/Form/AddPackageDetails';
import AddSideEffectForm from 'components/Form/AddSideEffectForm';
import AddActiveIngredientForm from 'components/Form/ActiveIngredientForm';
import SupplierForm from 'components/Form/AddSupplierForm'; // <-- import SupplierForm
import ManufacturerForm from 'components/Form/AddManufacturerForm'; // <-- import ManufacturerForm

import { FormType, GenericFormModalProps } from './formTypes';
import AddMedicineBasicForm from 'components/Form/AddMedicineBasicForm';

const formTitleMap = {
  [FormType.PACKAGE]: {
    add: 'Add New Package',
    edit: 'Edit Package',
  },
  [FormType.SIDE_EFFECT]: {
    add: 'Add Side Effect',
    edit: 'Edit Side Effect',
  },
  [FormType.ACTIVE_INGREDIENT]: {
    add: 'Add Active Ingredient',
    edit: 'Edit Active Ingredient',
  },
  [FormType.SUPPLIER]: {
    add: 'Add Supplier',
    edit: 'Edit Supplier',
  },
  [FormType.MANUFACTURER]: {
    add: 'Add Manufacturer',
    edit: 'Edit Manufacturer',
  },
  [FormType.MEDICINE]: {
    add: 'Add Medicine',
    edit: 'Edit Medicine',
  },
};

export const GenericFormModal: React.FC<GenericFormModalProps> = ({
  isOpen,
  toggle,
  formType,
  onSuccess,
  entityId,
  size = 'lg',
}) => {
  const { t } = useTranslation();
  const isEdit = Boolean(entityId);

  const renderForm = () => {
    switch (formType) {
      case FormType.PACKAGE:
        return <AddPackageDetails packageSizeId={entityId} onSuccess={onSuccess} />;
      case FormType.SIDE_EFFECT:
        return <AddSideEffectForm sideEffectId={entityId} onSuccess={onSuccess} />;
      case FormType.ACTIVE_INGREDIENT:
        return <AddActiveIngredientForm ingredientId={entityId} onSuccess={onSuccess} />;
      case FormType.SUPPLIER:
        return <SupplierForm supplierId={entityId} onSuccess={onSuccess} />;
      case FormType.MANUFACTURER:
        return <ManufacturerForm manufacturerId={entityId} onSuccess={onSuccess} />;
      case FormType.MEDICINE:
        return <AddMedicineBasicForm medicineId={entityId} onSuccess={onSuccess} />;
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size}>
      <ModalHeader toggle={toggle}>
        {t(isEdit ? formTitleMap[formType]?.edit : formTitleMap[formType]?.add)}
      </ModalHeader>
      <ModalBody>{renderForm()}</ModalBody>
    </Modal>
  );
};
